import {
  Component,
  forwardRef,
  Input
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-json-editor',
  templateUrl: './json-editor.component.html',
  styleUrls: ['./json-editor.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => JsonEditorComponent),
      multi: true,
    },
  ],
})
export class JsonEditorComponent implements ControlValueAccessor {
  jsonText: string = '';
  isInvalidJson: boolean = false;
  disabled: boolean = false;
  @Input() placeholder: string = 'Enter JSON here...';

  private onChange = (value: any) => { };
  private onTouched = () => { };

  onInput(event: Event) {
    const text = (event.target as HTMLTextAreaElement).value;

    this.jsonText = text;

    try {
      const parsedJson = JSON.parse(text);
      this.isInvalidJson = false;
      this.onChange(parsedJson);
      this.jsonText = JSON.stringify(parsedJson, null, 2);
    } catch (error) {
      this.isInvalidJson = true;
      this.onChange(null);
    }
  }

  writeValue(value: any): void {
    if (value !== undefined && value !== null) {
      this.jsonText = JSON.stringify(value, null, 2);
    } else {
      this.jsonText = '';
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
